import { PermissionKey } from 'auth/types';
import { GroupTitle } from 'pages/Clients/interfaces';

import { IComment } from './comment';

export type TSocials = Partial<{
  VK: {
    link: string;
  };
  discord: {
    link: string;
  };
  steam: {
    link: string;
  };
}>;

interface IPermission {
  id: number;
  alias: PermissionKey;
  title: string;
  description: string;
}

export type TRoleName =
  | 'manager'
  | 'operator'
  | 'finance'
  | 'sysadmin'
  | 'marketing'
  | 'other'
  | 'owner'
  | 'active_operator';

export interface IRole {
  id: number;
  alias: TRoleName;
  title: string;
  description: string;
  is_service: boolean;
  priority: number;
  permissions: Array<IPermission>;
}

export interface IPausableInfo {
  id: number;
  duration: number;
  elapsed: number;
  expires_at: string;
  tariff: {
    title: string;
  };
}

export interface IUser {
  id: number;
  uuid: string;
  nickname: string;
  phone: string;
  phone_suffix: string;
  dob: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  deposit: number;
  bonus: number;
  last_client_activity: string;
  last_worker_activity: string;
  last_comment: Pick<IComment, 'text' | 'is_important'> | null;
  pausable_info?: IPausableInfo;
  group: GroupTitle | null;
  creator: IUser | null;
  created_at: string;
  updated_at: string;
  disabled_at: string;
  banned_at: string | null;
  total_hours: number;
  roles: Array<IRole>;
  user_discount: number;
  discounts: TDiscounts[];
  role_ids: Array<number>;
  permissions: Array<IPermission>;
  __typename: 'User';
  avatar_url?: string;
  unverified: boolean;
}

export interface IWorker extends Omit<IUser, 'deposit' | 'last_comment'> {
  is_owner: boolean;
}

export type TClient = Pick<
  Partial<IUser>,
  | 'id'
  | 'uuid'
  | 'roles'
  | 'deposit'
  | 'created_at'
  | 'last_client_activity'
  | 'banned_at'
  | 'last_comment'
  | 'total_hours'
  | 'user_discount'
  | 'discounts'
  | 'phone'
  | 'nickname'
  | 'pausable_info'
  | 'group'
  | 'bonus'
  | 'avatar_url'
  | 'unverified'
>;

export type TWorker = Pick<
  Partial<IUser>,
  | 'phone'
  | 'nickname'
  | 'last_name'
  | 'first_name'
  | 'middle_name'
  | 'roles'
  | 'creator'
  | 'created_at'
  | 'disabled_at'
  | 'banned_at'
  | 'uuid'
  | 'unverified'
  | 'avatar_url'
>;

export type TDiscounts = {
  type: EDiscountsType;
  value: number;
};

export enum EDiscountsType {
  PERSONAL = 'PERSONAL',
  GROUP = 'GROUP',
  NETWORK = 'NETWORK',
}
